export const BANNER_URL = '/application-form/?label=specialists_page';
